// @flow

import React from 'react';
import LoadingElement from '../../loadingelement';

const LoadingModal = () => (
  <div className="generic_modal splash-page" data-toggle="modal">
    <div className="splash-prs-logo" />
    <LoadingElement />
  </div>
);

export default LoadingModal;
